/* North Country card buy box: pack pills update the variant + price, +/- steppers */
(function(){
  document.addEventListener('change', function(e){
    var r = e.target;
    if(!(r instanceof HTMLInputElement) || !r.closest('.nc-buy__pack')) return;
    var buy = r.closest('.nc-buy');
    var idInput = buy.querySelector('input[name="id"]');
    if(idInput) idInput.value = r.value;
    var card = buy.closest('.product-card');
    var sp = card ? card.querySelector('sale-price') : null;
    if(sp){
      var html = '<span class="sr-only">Price</span>' + r.dataset.price;
      if(r.dataset.unit) html += ' <span class="nc-buy__unit">(' + r.dataset.unit + ')</span>';
      sp.innerHTML = html;
    }
  });
  document.addEventListener('click', function(e){
    var b = e.target.closest('.nc-buy__step');
    if(!b) return;
    var i = b.parentElement.querySelector('input');
    var v = parseInt(i.value, 10) || 1;
    i.value = Math.max(1, v + parseInt(b.dataset.step, 10));
  });
})();

/* Do not pop the cart drawer open on every add - the header count still updates */
document.addEventListener('variant:add', function(e){ if(e.detail) e.detail.blockCartDrawerOpening = true; }, true);


/* Sep 28 safety net: if the theme's scripted add-to-cart does not land the item within 5 s, submit the form the plain HTML way (goes to the cart page). Never loses a click. */
(function(){
  function count(){ return fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();}).then(function(c){return c.item_count;}).catch(function(){return null;}); }
  document.addEventListener('submit', function(e){
    var f = e.target;
    if(!(f instanceof HTMLFormElement) || !f.classList.contains('nc-buy__form')) return;
    count().then(function(before){
      if(before === null) return;
      setTimeout(function(){
        count().then(function(after){
          if(after === null || after > before) return;
          if(f.querySelector('.nc-buy__error') || !document.body.contains(f)) return;
          try { HTMLFormElement.prototype.submit.call(f); } catch(err) {}
        });
      }, 5000);
    });
  }, true);
})();

/* nc-added-feedback (Oct 1): card Add to cart shows "Added" for a moment and the - / + count resets to 1, so a second tap adds exactly what the shopper sees */
(function(){
  var last=null;
  document.addEventListener('submit',function(e){var f=e.target&&e.target.closest&&e.target.closest('.nc-buy__form');if(f)last=f;},true);
  document.addEventListener('variant:add',function(){
    var f=last;last=null;if(!f)return;
    var q=f.querySelector('input[name="quantity"]');if(q)q.value=1;
    var b=f.querySelector('.nc-buy__add');if(!b)return;
    if(!b.dataset.ncLabel)b.dataset.ncLabel=b.innerHTML;
    b.innerHTML='Added \u2713';b.classList.add('nc-added');
    clearTimeout(b._ncT);b._ncT=setTimeout(function(){b.innerHTML=b.dataset.ncLabel;b.classList.remove('nc-added');},1600);
  });
})();
/* nc-cart-upgrade (Oct 2): fill in the delivery date when the cart redraws. The - / + buttons are the theme's own quantity-selector (snippets/line-item.liquid). */
(function(){
  var t;function run(){if(window.ncEtaAll&&document.querySelector('.nc-eta[hidden]'))window.ncEtaAll()}
  new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,60)}).observe(document.documentElement,{childList:true,subtree:true});
})();

/* nc-packup (Oct 2): "Switch" in the cart swaps a single for a pack, then redraws the cart */
document.addEventListener('click',function(e){
  var b=e.target.closest('.nc-packup__btn');if(!b)return;e.preventDefault();b.disabled=true;b.textContent='...';
  var u={};u[b.dataset.lineKey]=0;u[b.dataset.packId]=1;
  fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:u})})
    .then(function(r){return r.json()})
    .then(function(cart){document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:cart}}));if(location.pathname==='/cart')location.reload()})
    .catch(function(){b.disabled=false;b.textContent='Switch'});
});


/* nc-gift (Oct 24): free String Cheese single auto-adds at $200+ (matches the automatic discount "Free String Cheese on orders $200+"); removed again if the cart drops under $200 */
(function(){var GID=49555243827438,MIN=20000,busy=false,t;function cents(c){var s=0;c.items.forEach(function(i){if(!(i.properties&&i.properties._gift))s+=i.original_line_price;});return s;}function hasCode(c){var dc=function(d){return d&&d.type==='discount_code';};if((c.cart_level_discount_applications||[]).some(dc))return true;return c.items.some(function(i){return (i.line_level_discount_allocations||[]).some(function(a){return dc(a.discount_application);});});}function sync(){if(busy)return;busy=true;fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();}).then(function(c){var has=c.items.some(function(i){return i.variant_id===GID;});var gift=null;c.items.forEach(function(i){if(i.variant_id===GID&&i.properties&&i.properties._gift)gift=i;});var sub=cents(c);if(hasCode(c))sub=0;if(sub>=MIN&&!has){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:GID,quantity:1,properties:{_gift:'free'}})}).then(function(){return true;});}if(sub<MIN&&gift){var u={};u[gift.key]=0;return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:u})}).then(function(){return true;});}return false;}).then(function(changed){busy=false;if(!changed)return;fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();}).then(function(cart){document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:cart}}));if(location.pathname==='/cart')location.reload();});}).catch(function(){busy=false;});}function kick(){clearTimeout(t);t=setTimeout(sync,700);}document.addEventListener('variant:add',kick,true);document.documentElement.addEventListener('cart:refresh',function(e){if(!(e.detail&&e.detail.ncGift))kick();});document.addEventListener('DOMContentLoaded',kick);})();

/* NC Oct 27, Jack: Sampler Box cards have Add to cart + Subscribe & save side by side; the subscribe button fills the hidden selling_plan field before the form submits, Add to cart clears it */
document.addEventListener('click',function(e){var b=e.target.closest('.nc-buy__form button[type="submit"]');if(!b||!b.form)return;var sp=b.form.querySelector('input[name="selling_plan"]');if(!sp)return;sp.value=b.classList.contains('nc-buy__sub')?(b.dataset.plan||''):'';},true);
